import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api';
import { useAuth } from '../auth';
import { ErrorBox, PageHead, QueryView } from '../components/ui';
import { useLocale } from '../i18n';
import { qk } from '../queryClient';

/** The portal's order cut-off (decision 110): until this time the day before, a customer orders for or cancels a day. */
export function PortalSettingsPage() {
  const { t } = useLocale();
  const { me } = useAuth();
  const qc = useQueryClient();
  const settings = useQuery({ queryKey: qk.portalSettings, queryFn: ({ signal }) => api.portalSettings(signal) });
  const [cutoff, setCutoff] = useState<string | null>(null);
  const save = useMutation({
    mutationFn: (c: string) => api.savePortalSettings({ cutoff: c }),
    onSuccess: (s) => {
      qc.setQueryData(qk.portalSettings, s);
      void qc.invalidateQueries({ queryKey: ['portal'] });
      setCutoff(null);
    },
  });
  const owner = me?.role === 'owner';
  return (
    <div className="stack">
      <PageHead title={t('portalSettingsTitle')} back="/" />
      <p className="muted">{t('portalSettingsHint')}</p>
      <QueryView query={settings}>
        {(s) => {
          const value = cutoff ?? s.cutoff;
          return (
            <section className="card stack-sm">
              <label className="field">
                <span>{t('portalCutoffLabel')}</span>
                <input type="time" value={value} readOnly={!owner} onChange={(e) => setCutoff(e.target.value)} aria-label={t('portalCutoffLabel')} style={{ width: 140 }} />
              </label>
              {owner && cutoff !== null && cutoff !== s.cutoff ? (
                <button type="button" className="btn btn-primary btn-block" disabled={save.isPending || !/^\d{2}:\d{2}$/.test(cutoff)} onClick={() => save.mutate(cutoff)}>
                  {t('save')}
                </button>
              ) : null}
              {save.isSuccess && cutoff === null ? (
                <p className="note" role="status">
                  ✓ {t('saved')}
                </p>
              ) : null}
              {save.error ? <ErrorBox error={save.error} /> : null}
            </section>
          );
        }}
      </QueryView>
    </div>
  );
}
